<template>
    <div class="integrity">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div><img src="../../assets/img/index/CXGheader.png" alt="" style="width: 100%;"></div>
                    <div class="menuTab">
                        <div class="top">
                            <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                        </div>
                    </div>
                    <!-- 培训动态 轮播 活动通知 -->
                    <div class="line">
                        <div class="chunk style1">
                            <div class="publicTop">
                                <div class="title">培训动态</div>
                                <div class="more" @click="toPublicList('培训动态')">更多<i>》</i></div>
                            </div>
                            <div class="list">
                                <ul>
                                    <li v-for="(item, index) in trainDynamicList" :key="index">
                                        <div style="display: flex;justify-content: left;align-items: center;width: 70%;" @click="toDetail(item, '培训动态详情')">
                                            <span class="point"></span>
                                            <span class="title">{{ item.title }}</span>
                                        </div>
                                        <div style="color: #999;width: 30%;text-align: right;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="chunk swiper">
                            <el-carousel trigger="click" height="252px">
                              <el-carousel-item v-for="(item, index) in swiperList" :key="index">
                                <img :src="item.newCoverImg" alt="" style="cursor: pointer;" @click="toDetail(item, '培训动态详情')"  @error="imgErrorNews">
                                <div class="bottomText">
                                    <span>{{ item.title }}</span>
                                </div>
                              </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div class="chunk activity">
                            <div class="publicTop">
                                <div class="title">活动通知</div>
                                <div class="more" @click="toPublicList('活动通知')">更多<i>》</i></div>
                            </div>
                            <div class="list">
                                <ul>
                                    <li v-for="(item, index) in activityList" :key="index">
                                        <div style="display: flex;justify-content: left;align-items: center;width: 70%;" @click="toDetail(item, '活动通知详情')">
                                            <span class="point"></span>
                                            <span class="title">{{ item.title }}</span>
                                        </div>
                                        <div style="color: #999;width: 30%;text-align: right;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- 政策文件 优秀学员 证书查询 -->
                    <div class="line">
                        <div class="chunk style1">
                            <div class="publicTop">
                                <div class="title">政策文件</div>
                                <div class="more" @click="toPublicList('政策文件')">更多<i>》</i></div>
                            </div>
                            <div class="list">
                                <ul>
                                    <li v-for="(item, index) in policyList" :key="index">
                                        <div style="display: flex;justify-content: left;align-items: center;" @click="toDetail(item, '政策文件详情')">
                                            <span class="point"></span>
                                            <span class="title">{{ item.title }}</span>
                                        </div>
                                        <div style="color: #999;" v-if="item.publishTime">{{ time(item.publishTime) }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="chunk credit">
                            <div class="publicTop">
                                <div class="title">优秀学员</div>
                                <div class="more" @click="toStudents">更多<i>》</i></div>
                            </div>
                            <div class="list">
                                <ul>
                                    <li v-for="(item, index) in evaluateList" :key="index"  @click="toGoodStudents(item, index)">
                                        <span class="title">{{ item.name }}</span>
                                        <div class="point"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="chunk certificateSearch">
                            <div class="publicTop">
                                <div class="title">证书查询</div>
                                <div class="more" @click="toSearchList('证书查询')">更多<i>》</i></div>
                            </div>
                            <div class="from">
                                <el-input  placeholder="学员姓名" v-model="searchFrom.name" clearable>
                                    <img slot="prefix" src="../../assets/img/index/certificateSearch1.png" alt="">
                                </el-input>
                                <el-input  placeholder="证书编号" v-model="searchFrom.code" style="margin-top: 20px;" clearable >
                                    <img slot="prefix" src="../../assets/img/index/certificateSearch2.png" alt="">
                                </el-input>
                                <el-button @click="search">查询</el-button>
                            </div>
                        </div>
                    </div>

                    <!-- 师资介绍 -->
                    <div class="teachers">
                        <div class="publicTop">
                            <div class="title">师资介绍</div>
                            <div class="more" @click="toPersonSearch('师资介绍')">更多<i>》</i></div>
                        </div>
                        <div class="teachersContent">
                            <div id="click-scroll-X">
                                <span class="left_btn el-icon-arrow-left" @click="leftSlide('wrapperCon1', 18)"></span>
                                <div class="scroll_wrapper" ref="wrapperCon1">
                                  <div class="scroll_list">
                                    <div class="item" v-for="(item,index) in teachersList" :key="index" @click="toPersonDetail(item, '师资介绍')">
                                        <img :src="baseUrl + item.peopleImg" alt="" @error="imgError">
                                        <div style="text-align: center;margin-top: 10px;">{{ item.name }}</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="right_btn el-icon-arrow-right" @click="rightSlide('wrapperCon1', 18)"></div>
                            </div>
                        </div>
                    </div>

                    <!-- 培训课程 -->
                    <div class="curriculum">
                        <div class="publicTop">
                            <div class="title">培训课程</div>
                            <div class="more" @click="toPublicList('培训课程')">更多<i>》</i></div>
                        </div>
                        <div class="curriculumContent">
                            <div id="click-scroll-X">
                                <span class="left_btn el-icon-arrow-left" @click="leftSlide('wrapperCon2', 28)"></span>
                                <div class="scroll_wrapper" ref="wrapperCon2">
                                  <div class="scroll_list">
                                    <div class="item" v-for="(item,index) in curriculumList" :key="index" @click="toDetail(item, '培训课程详情')">
                                        <img :src="baseUrl + item.coverImg" alt="" @error="imgError2">
                                        <div style="text-align: center;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.title }}</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="right_btn el-icon-arrow-right" @click="rightSlide('wrapperCon2', 28)"></div>
                            </div>
                        </div>
                    </div>

                    <!-- 推荐图书 -->
                    <div class="books">
                        <div class="publicTop">
                            <div class="title">推荐图书</div>
                            <div class="more" @click="toPublicList('推荐图书')">更多<i>》</i></div>
                        </div>
                        <div class="booksContent">
                            <div id="click-scroll-X">
                                <span class="left_btn el-icon-arrow-left" @click="leftSlide('wrapperCon3', 18)"></span>
                                <div class="scroll_wrapper" ref="wrapperCon3">
                                  <div class="scroll_list">
                                    <div class="item" v-for="(item,index) in booksList" :key="index" @click="toDetail(item, '推荐图书详情')">
                                        <img :src="baseUrl + item.coverImg" alt="" @error="imgError3">
                                        <div style="text-align: center;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;color: #666;">{{ item.title }}</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="right_btn el-icon-arrow-right" @click="rightSlide('wrapperCon3', 18)"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'integrity',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            baseUrl: baseURL,
            menuTabList: [
                {
                    name: '首页',
                    title: '企业诚信官',
                    url: '/integrity'
                },
                {
                    name: '培训动态',
                    title: '培训动态',
                    url: '/integrity_list'
                },
                // {
                //     name: '新闻图片',
                //     title: '新闻图片',
                //     url: '/integrity_list'
                // },
                {
                    name: '活动通知',
                    title: '活动通知',
                    url: '/integrity_list'
                },
                {
                    name: '政策文件',
                    title: '政策文件',
                    url: '/integrity_list'
                },
                {
                    name: '优秀学员',
                    title: '优秀学员',
                    url: '/goodStudents'
                },
                {
                    name: '证书查询',
                    title: '证书查询',
                    url: '/certificateSearch_list'
                },
                {
                    name: '师资介绍',
                    title: '师资介绍',
                    url: '/integrity_search'
                },
                {
                    name: '培训课程',
                    title: '培训课程',
                    url: '/integrity_list'
                },
                {
                    name: '推荐图书',
                    title: '推荐图书',
                    url: '/integrity_list'
                },
            ],
            trainDynamicList: [
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '守信践诺守信践诺守信践诺守信践诺守信践诺守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于培育诚信经营、守信践诺',
                //     time: '2023-08-21'
                // },
            ],
            swiperList: [
                // {
                //     imgUrl: require('../../assets/img/swiper/swiper1.png'),
                //     title: '《全国诚信经营示范企业要求》和《全国优秀《全国优秀《全国优秀'
                // },
                // {
                //     imgUrl: require('../../assets/img/swiper/swiper2.png'),
                //     title: '《全国诚信经营示范企业要求》和《全国优秀《全国优秀'
                // },
                // {
                //     imgUrl: require('../../assets/img/swiper/swiper3.png'),
                //     title: '《全国诚信经营示范企业要求》和《全国优秀《全国优秀'
                // },
                // {
                //     imgUrl: require('../../assets/img/swiper/swiper4.png'),
                //     title: '《全国诚信经营示范企业要求》和《全国优秀《全国优秀'
                // }
            ],
            activityList: [ //活动通知列表
                // {
                //     title: '关于开展2023年"诚信兴诚信兴诚信兴诚信兴诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
                // {
                //     title: '关于开展2023年"诚信兴',
                //     time: '2023-08-21'
                // },
            ],
            policyList: [],
            evaluateList: [ //优秀学员列表
                // {
                //     name: '优秀学员',
                // },
                // {
                //     name: '优秀学员',
                // },
                // {
                //     name: '优秀学员',
                // },
                // {
                //     name: '优秀学员',
                // },
                // {
                //     name: '优秀学员',
                // },
            ],
            searchFrom: {
                name: '',
                code: ''
            },
            teachersList: [
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers1.png'),
                //     name: '孙木'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers2.png'),
                //     name: '李林'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers3.png'),
                //     name: '孙楮'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers4.png'),
                //     name: '赵轩海'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers5.png'),
                //     name: '冯丽妍'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers6.png'),
                //     name: '吴彦霖'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers7.png'),
                //     name: '冯国安'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers4.png'),
                //     name: '赵轩海'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers5.png'),
                //     name: '冯丽妍'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers6.png'),
                //     name: '吴彦霖'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/teachers7.png'),
                //     name: '冯国安'
                // },
            ],
            curriculumList: [
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum1.png'),
                //     name: '· 北京精雕JDSoft JDSoft SurfMilJDSoft SurfMil'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum2.png'),
                //     name: '· 北京精雕JDSoft SurfMil...'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum3.png'),
                //     name: '· 北京精雕JDSoft SurfMil...'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum4.png'),
                //     name: '· · 北京精雕JDSoft SurfMil...'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum5.png'),
                //     name: '· 北京精雕JDSoft SurfMil...'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum3.png'),
                //     name: '· 北京精雕JDSoft SurfMil...'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum4.png'),
                //     name: '· 北京精雕JDSoft SurfMil...'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/curriculum5.png'),
                //     name: '· 北京精雕JDSoft SurfMil...'
                // },
            ],
            booksList: [
                // {
                //     imgUrl: require('../../assets/img/testImg/books1.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books2.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books3.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books4.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books5.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books6.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books7.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books5.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books6.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
                // {
                //     imgUrl: require('../../assets/img/testImg/books7.png'),
                //     name: '图解本草纲目极简养生+图解黄帝内经极简养生速查全书（全两册）'
                // },
            ]
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        this.qycxgIndex()
    },
    mounted() {
    },
    methods: {
        // 左箭头
        leftSlide(refName, addnum) {
            // 保存滚动盒子左侧已滚动的距离
            let left = this.$refs[refName].scrollLeft
            let num = 0
            clearInterval(this.timer)
            this.timer = null
            this.timer = setInterval(() => {
                //   !left:已经滚动到最左侧
                //   一次性滚动距离（可调节）
                if (!left || num >= 300) {
                // 停止滚动
                clearInterval(this.timer)
                this.timer = null
                return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs[refName].scrollLeft = left -= addnum
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += 30
            }, 20)
            // 20：速度（可调节）
        },
        // 右箭头
        rightSlide(refName, addnum) {
            // 保存滚动盒子左侧已滚动的距离
            let left = this.$refs[refName].scrollLeft
            // 保存元素的整体宽度
            let scrollWidth = this.$refs[refName].scrollWidth
            // 保存元素的可见宽度
            let clientWidth = this.$refs[refName].clientWidth
            let num = 0
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                // 已经滚动距离+可见宽度
                // left+clientWidth>=scrollWidth：滚动到最右侧
                // num>=300一次性滚动距离
                if (left + clientWidth >= scrollWidth || num >= 300) {
                clearInterval(this.timer)
                return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs[refName].scrollLeft = left += addnum
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += 30
            }, 20)
            // 20：速度（可调节）
        },

        // 获取置顶文章
        qycxgIndex() {
            let _this = this
            api.qycxgIndex().then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.getGoodStudents()
                    _this.getListTeacher()
                    _this.getCourseList()
                    _this.getBookList()
                    data.data.cate19.forEach(element => {
                        element.newCoverImg = baseURL + element.coverImg
                    });
                    _this.trainDynamicList = data.data.cate19
                    _this.swiperList = data.data.cate19
                    _this.activityList = data.data.cate20
                    _this.policyList = data.data.cate21

                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取优秀学员
        getGoodStudents() {
            let _this = this
            let params = {
                param: '',
                page: 1,
                limit: 5,
            }
            api.getGoodStudents(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.evaluateList = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取师资介绍
        getListTeacher() {
            let _this = this
            let params = {
                param: '',
                page: 1,
                limit: 10,
            }
            api.getListTeacher(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.teachersList = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 培训课程
        getCourseList() {
            let _this = this
            let params = {
                cateId: 24,
                title: '',
                page: 1,
                size: 10,
            }
            api.getList(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.curriculumList = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 推荐图书
        getBookList() {
            let _this = this
            let params = {
                cateId: 25,
                title: '',
                page: 1,
                size: 10,
            }
            api.getList(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.booksList = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 师资图片错误回调
        imgError(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/testImg/teachers7.png');
            img.onerror = null; //控制不要一直跳动 
        },

        // 培训课程图片错误回调
        imgError2(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/testImg/criterion1.png');
            img.onerror = null; //控制不要一直跳动 
        },

        // 推荐图书图片错误回调
        imgError3(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/testImg/books3.png');
            img.onerror = null; //控制不要一直跳动 
        },

        // 轮播图片错误
        imgErrorNews(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/index/news.webp');
            img.onerror = null; //控制不要一直跳动 
        },

        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },

        // 证书查询
        search() {
            let _this = this
            let params = {
                name: _this.searchFrom.name,
                code: _this.searchFrom.code
            }

            let title = '企业诚信官'

            this.$router.push({
                name: 'certificateSearch_list',
                query: {
                    documentTitle: title,
                    from: JSON.stringify(params)
                }
            })

            // let routeUrl = this.$router.resolve({
            //   path: "/certificateSearch_list"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&from=' + JSON.stringify(params), '_blank');
        },

        // 前往公共列表2
        toPublicList(title) {
            this.$router.push({
                name: 'integrity_list',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity_list"
            // });
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 前往详情
        toDetail(item, title) {
            this.$router.push({
                name: 'integrity_detail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity_detail"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },

        // 优秀学员点击
        toGoodStudents(item, index) {
            // let routeUrl = this.$router.resolve({
            //   path: "/integrityResult"
            // });
            let title = '优秀学员'

            this.$router.push({
                name: 'integrityResult',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },
        // 优秀学员更多点击
        toStudents() {
            // let routeUrl = this.$router.resolve({
            //   path: "/goodStudents"
            // });
            let title = '优秀学员'
            
            this.$router.push({
                name: 'goodStudents',
                query: {
                    documentTitle: title
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 人物搜索跳转
        toPersonSearch(title) {
            this.$router.push({
                name: 'integrity_search',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity_search"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 前往人物详情
        toPersonDetail(item, title) {
            let text = title + '详情'
            this.$router.push({
                name: 'integrity_detail',
                query: {
                    documentTitle: text,
                    id: item.id,
                    isPerson: true
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity_detail"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + text + '&id=' + item.id + '&isPerson=true', '_blank');
        },

        // 前往证书搜索列表
        toSearchList(title) {
            this.$router.push({
                name: 'certificateSearch_list',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/certificateSearch_list"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
            
        },
        // 时间过滤
        time(time) {
            return time.substring(5,10)
        },
    }
}
</script>

<style lang="less" scoped>
.integrity {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 20px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
                .publicTop {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    border-bottom: 1px solid #85B2FF;
                    background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                    .title {
                        color: #134AA6;
                        font-size: 20px;
                    }
                    .more {
                        font-size: 14px;
                        color: #999;
                        cursor: pointer;
                    }
                }
                .line {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    .chunk {
                        width: 32.5%;
                        height: 254px;
                        border: 1px solid #5797FF;
                    }
                    .style1 {
                        .list {
                            ul {
                                margin-top: 3px;
                            }
                            li {
                                display: flex;
                                justify-content: space-between;
                                padding: 7px 10px;
                                .point {
                                    width: 12px;
                                    height: 14px;
                                    border-radius: 0;
                                    background-color: none;
                                    background: url('../../assets/img/index/arrows2.png') no-repeat;
                                }
                                .title {
                                    margin-left: 10px;
                                    overflow: hidden;
                                    cursor: pointer;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                                .title:hover {
                                    color: #258AFF;
                                }
                            }
                        }
                    }
                    .swiper {
                        img {
                            width: 100%;
                            height: 252px;
                            object-fit: contain;
                        }
                        /deep/ .el-carousel__button {
                            width: 8px;
                            height: 8px;
                            border-radius: 8px;
                            opacity: 1;
                            background: none;
                            border: 1px solid #AEAEAE;
                        }
                        /deep/ .el-carousel__indicator--horizontal {
                            padding: 13px 2px;
                        }
                        /deep/ .el-carousel__indicator.is-active button {
                            background: #1A68E8;
                            border: 1px solid #1A68E8;
                        }
                        /deep/ .el-carousel__indicators--horizontal {
                            transform: none;
                            left: auto;
                            right: 0;
                            padding: 0 10px;
                        }
                        .bottomText {
                            position: absolute;
                            bottom: 0;
                            background: rgba(0, 0, 0, 50%);
                            color: #fff;
                            width: 100%;
                            height: 34px;
                            line-height: 34px;
                            border-top: 1px solid #5797FF;
                            span {
                                display: inline-block;
                                width: 340px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                padding: 0 10px;
                            }
                        }
                    }
                    .activity {
                        .list {
                            ul {
                                margin-top: 3px;
                            }
                            li {
                                display: flex;
                                justify-content: space-between;
                                padding: 7px 10px;
                                .point {
                                    width: 12px;
                                    height: 14px;
                                    border-radius: 0;
                                    background-color: none;
                                    background: url('../../assets/img/index/arrows2.png') no-repeat;
                                }
                                .title {
                                    margin-left: 10px;
                                    overflow: hidden;
                                    cursor: pointer;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    width: 280px;
                                }
                                .title:hover {
                                    color: #258AFF;
                                }
                            }
                        }
                    }
                    .credit {
                        .list {
                            ul {
                                margin-top: 3px;
                            }
                            li {
                                display: flex;
                                justify-content: space-between;
                                padding: 7px 20px;
                                .point {
                                    width: 13px;
                                    height: 20px;
                                    border-radius: 0;
                                    background-color: none;
                                    background: url('../../assets/img/index/arrows3.png') no-repeat;
                                }
                                .title {
                                    overflow: hidden;
                                    cursor: pointer;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    width: 280px;
                                    color: #258AFF;
                                }
                            }
                        }
                    }
                    .certificateSearch {
                        /deep/ .el-input__prefix {
                            display: flex;
                            align-items: center;
                            margin-left: 10px;
                        }
                        /deep/ .el-input__inner {
                            padding-left: 40px;
                            border-color: #C4C4C4;
                            color: #333;
                            border-radius: 1px;
                        }
                        /deep/ .el-button {
                            border-radius: 1px;
                            background-color: #1A68E8;
                            width: 100%;
                            color: #fff;
                            margin-top: 20px;
                        }
                        .from {
                            padding: 20px;
                        }
                    }
                }
                .teachers {
                    border: 1px solid #5797FF;
                    margin-top: 15px;
                    .teachersContent {
                        padding: 15px;
                        #click-scroll-X {
                            display: flex;
                            align-items: center;
                            margin-top: 10px;
                            /*隐藏滚动条*/
                            .scroll_wrapper::-webkit-scrollbar {
                                display: none;
                            }
                            .left_btn, .right_btn {
                                font-size: 20px;
                                cursor: pointer;
                                margin: -10px 15px 0;
                                color: #999;
                                padding: 19px 0;
                                color: #999;
                                background-color: #CDCDCD;
                                font-weight: 700;
                            }

                            .scroll_wrapper {
                                width: 100%;
                                overflow-x: scroll;
                                padding-bottom: 10px;
                                // width: 935px;

                                .scroll_list {
                                    display: flex;
                                    align-items: center;
                                    justify-content: left;
                                    cursor: pointer;
                                    .item {
                                        width: 115px;
                                        height: 204px;
                                        flex-shrink: 0;
                                        margin: 0 35px;
                                        position: relative;
                                        img {
                                            width: 100%;
                                            height: 170px;
                                            object-fit: contain;
                                        }
                                    }
                                    .item:hover {
                                        background-color: #f3f9fd;
                                    }
                                }
                            }
                        }
                    }
                }
                .curriculum {
                    border: 1px solid #5797FF;
                    margin-top: 15px;
                    .curriculumContent {
                        padding: 15px;
                        #click-scroll-X {
                            display: flex;
                            align-items: center;
                            margin-top: 10px;
                            /*隐藏滚动条*/
                            .scroll_wrapper::-webkit-scrollbar {
                                display: none;
                            }
                            .left_btn, .right_btn {
                                font-size: 20px;
                                cursor: pointer;
                                margin: -10px 15px 0;
                                color: #999;
                                padding: 19px 0;
                                color: #999;
                                background-color: #CDCDCD;
                                font-weight: 700;
                            }

                            .scroll_wrapper {
                                width: 100%;
                                overflow-x: scroll;
                                padding-bottom: 10px;
                                // width: 935px;

                                .scroll_list {
                                    display: flex;
                                    align-items: center;
                                    justify-content: left;
                                    cursor: pointer;
                                    .item {
                                        width: 179px;
                                        height: 168px;
                                        flex-shrink: 0;
                                        margin: 0 45px;
                                        position: relative;
                                        img {
                                            width: 100%;
                                            height: 145px;
                                            object-fit: contain;
                                        }
                                    }
                                    .item:hover {
                                        background-color: #f3f9fd;
                                    }
                                }
                            }
                        }
                    } 
                }
                .books {
                    border: 1px solid #5797FF;
                    margin-top: 15px;
                    .booksContent {
                        padding: 15px;
                        #click-scroll-X {
                            display: flex;
                            align-items: center;
                            margin-top: 10px;
                            /*隐藏滚动条*/
                            .scroll_wrapper::-webkit-scrollbar {
                                display: none;
                            }
                            .left_btn, .right_btn {
                                font-size: 20px;
                                cursor: pointer;
                                margin: -10px 15px 0;
                                color: #999;
                                padding: 19px 0;
                                color: #999;
                                background-color: #CDCDCD;
                                font-weight: 700;
                            }

                            .scroll_wrapper {
                                width: 100%;
                                overflow-x: scroll;
                                padding-bottom: 10px;
                                // width: 935px;

                                .scroll_list {
                                    display: flex;
                                    align-items: center;
                                    justify-content: left;
                                    cursor: pointer;
                                    .item {
                                        width: 115px;
                                        height: 200px;
                                        flex-shrink: 0;
                                        margin: 0 38px;
                                        position: relative;
                                        img {
                                            width: 100%;
                                            height: 145px;
                                            object-fit: contain;
                                        }
                                    }
                                    .item:hover {
                                        background-color: #f3f9fd;
                                    }
                                }
                            }
                        }
                    } 
                }
            }
        }
    }
}
</style>

